// Once https://github.com/nuxt/nuxt/issues/25891 will be fixed
// This middleware should be moved in the middleware directory of the auth layer
// For now it needs to stay here so it is executed after the external-url-handler global middleware

export default defineNuxtRouteMiddleware(async (to) => {
  const { initImpersonation } = useImpersonate()

  const impersonatedRouteLocation = await initImpersonation(to)

  if (!impersonatedRouteLocation) {
    return
  }

  return navigateTo(impersonatedRouteLocation)
})
